import styled from 'styled-components';

export const PropertiesBox = styled.div`
  background: ${({ theme }) => theme.palette.primary.background};
  border-radius: 21px;
  padding: 20px 15px;
`;
